import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Pause from '../Icons/Pause2';
import Play from '../Icons/Play2';

const StyledMediaTile = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 133.33%;
  background: linear-gradient(to bottom, #e5e5e5, #f7f7f7);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: zoom-in;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

interface VideoTileProps {
  marketingVideoPreview: string;
  index: number;
  handleTileClick: (index: number) => void;
}

const VideoTile: React.FC<VideoTileProps> = ({
  marketingVideoPreview,
  index,
  handleTileClick,
}) => {
  const [playVideo, setPlayVideo] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  // A ref used as a lock to prevent rapid toggling
  const toggleLock = useRef(false);

  const togglePlayback = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (toggleLock.current) return;

    toggleLock.current = true;
    if (videoRef.current) {
      if (playVideo) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setPlayVideo((prev) => !prev);
    }
    // Release the lock after 200ms (adjust as needed)
    setTimeout(() => {
      toggleLock.current = false;
    }, 200);
  };

  return (
    <StyledMediaTile onClick={() => handleTileClick(index + 1)}>
      <video
        ref={videoRef}
        src={marketingVideoPreview}
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          willChange: 'transform, opacity',
        }}
      />
      <div
        onClick={(e)=>togglePlayback(e)}
        style={{
          position: 'absolute',
          bottom: '24px',
          right: '32px',
          zIndex: 2,
          cursor: 'pointer',
        }}
      >
        {playVideo ? <Pause /> : <Play />}
      </div>
    </StyledMediaTile>
  );
};

export default React.memo(VideoTile);
